module.exports = __webpack_public_path__ + "img/23FA.42183404.svg";